import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';

class EQ10Effect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect tall-effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='31'
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain31Parameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                       sequencerEngine={this.props.sequencerEngine}
                        step={0.1}
                        max={12}
                        min={-12}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='63'
                       sequencerEngine={this.props.sequencerEngine}
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain63Parameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='125'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain125Parameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                         unit='db'
                        step={0.1}
                        max={12}
                        min={-12}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='250'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain250Parameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                         unit='db'
                        step={0.1}
                        max={12}
                        min={-12}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='500'
                        selectedParameter={this.props.selectedParameter}
                       sequencerEngine={this.props.sequencerEngine}
                        parameter={this.state.effect.gain500Parameter}
                        onParameterChanged={this.props.onParameterChanged}
                         unit='db'
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                       sequencerEngine={this.props.sequencerEngine}
                        name='1k'
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain1kParameter}
                        onParameterChanged={this.props.onParameterChanged}
                         lfoEnabled={true}
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='2k'
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                       sequencerEngine={this.props.sequencerEngine}
                        parameter={this.state.effect.gain2kParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='4k'
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain4kParameter}
                        onParameterChanged={this.props.onParameterChanged}
                         lfoEnabled={true}
                        isParameter={true}
                        step={0.1}
                        max={12}
                       sequencerEngine={this.props.sequencerEngine}
                        min={-12}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='8k'
                         unit='db'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain8kParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                         unit='db'
                        name='16k'
                        selectedParameter={this.props.selectedParameter}
                        parameter={this.state.effect.gain16kParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.1}
                        max={12}
                        min={-12}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                        />
 
                </div>} 
            </div>
        );
    }
}

export default EQ10Effect;
